/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_DecimalsInputs */

const en_reference_field_decimals = /** @type {(inputs: Reference_Field_DecimalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decimals`)
};

/**
* | output |
* | --- |
* | "Decimals" |
*
* @param {Reference_Field_DecimalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_decimals = /** @type {((inputs?: Reference_Field_DecimalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_DecimalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_decimals(inputs)
});